import React, { useEffect, useRef, useState } from "react";
import "./Logistics.css";
import logo from "../../assets/WHL-LOGO.png";
import axiosInstance from "../../services/auth";
import { toast, ToastContainer } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import { useCombinedContext } from "../../context/CombinedContext";

const PurchaseView = ({
  purchase,
  isViewMode,
  setIsViewMode,
  companyId,
  onUpdate,
}) => {
  // console.log("FoodAllowance data for view report", purchase);
  const { selectedCompany } = useCombinedContext();
  const company = selectedCompany;

  // Ref for printing
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // Prevent background scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      isViewMode();
    }
  };

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return (
    isViewMode && (
      <>
        <div
          className={`modal fade ${isViewMode ? "show d-block" : ""}`}
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          tabIndex="-1"
          role="dialog"
          aria-hidden={!isViewMode}
          onClick={(e) => {
            if (e.target.classList.contains("modal")) setIsViewMode(false);
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content purchase_model">
              <div className="modal-header text-white text-center vesel_form">
                <h5 className="modal-title">Purchase Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setIsViewMode(false)}
                ></button>
              </div>
              <div ref={printRef} className="modal-body modalWhite">
                <div className="food_head" style={{ marginBottom: "25px" }}>
                  <div style={{ flex: "0 0 auto" }}>
                    <img
                      src={logo}
                      alt="logo"
                      style={{
                        width: "125px",
                        height: "auto",
                        paddingRight: "20px",
                      }}
                    />
                  </div>
                  <div
                    style={{ textAlign: "left", flex: "1", padding: "0 5px" }}
                  >
                    <h2
                      className="company_font"
                      style={{ margin: 0, textDecoration: "underline" }}
                    >
                      {company.company_name}
                    </h2>
                    <p style={{ margin: 0, fontSize: "12px" }}>
                      {`Co Reg No: ${company.co_regno} GST No: ${company.gst_no}`}
                      <br />
                      {company.address}
                      <br />
                      {`Tel: ${company.telephone} Fax: ${company.fax}`}
                      <br />
                      {company.email}
                    </p>
                  </div>
                </div>
                <hr />
                <div>
                  <p className="mt-3">
                    <strong>Shop Name:</strong> {purchase.shopName}
                  </p>
                  <p>
                    <strong>Invoice No:</strong> {purchase.invoiceNo}
                  </p>
                  <p>
                    <strong>Invoice Date:</strong>{" "}
                    {purchase.invoiceDate
                      ? new Date(purchase.invoiceDate).toLocaleDateString()
                      : "N/A"}
                  </p>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h6>Material Details:</h6>
                  </div>
                  {purchase && purchase?.items.length > 0 ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Sl No</th>
                          <th>Material Name</th>
                          <th>Description</th>
                          <th>Quantity</th>
                          <th>Unit Price</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {purchase?.items.map((detail, index) => (
                          <tr key={detail._id}>
                            <td>{index + 1}</td>
                            <td>{detail.item || "N/A"}</td>
                            <td>{detail.description || "N/A"}</td>
                            <td>{detail.quantity || "N/A"}</td>

                            <td>$ {formatPrice(detail.unitPrice) || "N/A"}</td>
                            <td>$ {formatPrice(detail.amount) || "N/A"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No food details available.</p>
                  )}
                  <p>
                    <strong>Total Amount:</strong> ${" "}
                    {formatPrice(purchase.totalAmount)}
                  </p>
                  <p>
                    <strong>Remarks:</strong> {purchase.remarks}
                  </p>
                </div>
              </div>
              <div className="text-center">
                <button className="button-2 mb-5" onClick={handlePrint}>
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </>
    )
  );
};

export default PurchaseView;
